// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Unknown Action`
};

const de_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Unbekannte Aktion`
};

const es_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Acción Desconocida`
};

const fr_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Action inconnue`
};

const fi_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Tuntematon toiminto`
};

const hi_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `अज्ञात कार्य`
};

const ja_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `不明なアクション`
};

const nl_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Onbekende actie`
};

const pt_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Ação Desconhecida`
};

const ro_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Acțiune necunoscută`
};

const th_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `การดำเนินการที่ไม่รู้จัก`
};

const ur_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `نامعلوم ایکشن`
};

const zh_hant1_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `未知操作`
};

const da_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Ukendt handling`
};

const it_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Azione Sconosciuta`
};

const vn_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Hành Động Không Xác Định`
};

const ko_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `알 수 없는 액션`
};

const tr_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Bilinmeyen Eylem`
};

const lv_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Nezināma darbība`
};

const ar_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `إجراء غير معروف`
};

const bs_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Nepoznata akcija`
};

const sl_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Neznana akcija`
};

const id_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Aksi Tidak Dikenal`
};

const sv_widget_actions_unknown_action = /** @type {(inputs: {}) => string} */ () => {
	return `Okänd åtgärd`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_actions_unknown_action = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_actions_unknown_action(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_actions_unknown_action", locale)
	if (locale === "en") return en_widget_actions_unknown_action(inputs)
	if (locale === "de") return de_widget_actions_unknown_action(inputs)
	if (locale === "es") return es_widget_actions_unknown_action(inputs)
	if (locale === "fr") return fr_widget_actions_unknown_action(inputs)
	if (locale === "fi") return fi_widget_actions_unknown_action(inputs)
	if (locale === "hi") return hi_widget_actions_unknown_action(inputs)
	if (locale === "ja") return ja_widget_actions_unknown_action(inputs)
	if (locale === "nl") return nl_widget_actions_unknown_action(inputs)
	if (locale === "pt") return pt_widget_actions_unknown_action(inputs)
	if (locale === "ro") return ro_widget_actions_unknown_action(inputs)
	if (locale === "th") return th_widget_actions_unknown_action(inputs)
	if (locale === "ur") return ur_widget_actions_unknown_action(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_actions_unknown_action(inputs)
	if (locale === "da") return da_widget_actions_unknown_action(inputs)
	if (locale === "it") return it_widget_actions_unknown_action(inputs)
	if (locale === "vn") return vn_widget_actions_unknown_action(inputs)
	if (locale === "ko") return ko_widget_actions_unknown_action(inputs)
	if (locale === "tr") return tr_widget_actions_unknown_action(inputs)
	if (locale === "lv") return lv_widget_actions_unknown_action(inputs)
	if (locale === "ar") return ar_widget_actions_unknown_action(inputs)
	if (locale === "bs") return bs_widget_actions_unknown_action(inputs)
	if (locale === "sl") return sl_widget_actions_unknown_action(inputs)
	if (locale === "id") return id_widget_actions_unknown_action(inputs)
	if (locale === "sv") return sv_widget_actions_unknown_action(inputs)
	return "widget_actions_unknown_action"
};